(() => {
  class VeiledCategoryStory {
    constructor(section) {
      this.section = section;
      this.cards = Array.from(section.querySelectorAll("[data-vcs-card]"));
      this.bg = section.querySelector(".veiled-category-story__bg");
      this.indexEl = section.querySelector("[data-vcs-index]");
      this.titleEl = section.querySelector("[data-vcs-title]");
      this.copyEl = section.querySelector("[data-vcs-copy]");
      this.button = section.querySelector("[data-vcs-button]");
      this.buttonText = section.querySelector("[data-vcs-button-text]");

      this.activeIndex = -1;
      this.timer = null;

      this.autoplay = section.dataset.autoplay === "true";
      this.autoplaySpeed = Number(section.dataset.autoplaySpeed || 5000);

      this.handleCardClick = this.handleCardClick.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);

      this.init();
    }

    init() {
      if (!this.cards.length) return;

      this.cards.forEach((card, index) => {
        card.addEventListener("click", this.handleCardClick);
        card.addEventListener("mouseenter", this.handleMouseEnter);
        card.dataset.vcsIndex = String(index);
      });

      this.activate(0, false);

      if (this.autoplay) {
        this.startAutoplay();
        this.section.addEventListener("mouseenter", this.handleMouseEnter);
        this.section.addEventListener("mouseleave", this.handleMouseLeave);
      }
    }

    handleCardClick(event) {
      const card = event.currentTarget;
      const index = Number(card.dataset.vcsIndex);

      this.activate(index, true);
      this.restartAutoplay();
    }

    handleMouseEnter() {
      this.stopAutoplay();
    }

    handleMouseLeave() {
      if (this.autoplay) this.startAutoplay();
    }

    activate(index, animate = true) {
      const card = this.cards[index];
      if (!card) return;

      if (index === this.activeIndex) {
        this.updateActiveStates(index);
        return;
      }

      this.activeIndex = index;

      const bg = card.dataset.bg;
      const indexText = card.dataset.index || "";
      const title = card.dataset.title || "";
      const copy = card.dataset.copy || "";
      const buttonLabel = card.dataset.buttonLabel || "";
      const buttonUrl = card.dataset.buttonUrl || "";

      this.updateActiveStates(index);

      if (!animate) {
        this.updateContent({ bg, indexText, title, copy, buttonLabel, buttonUrl });
        return;
      }

      this.section.classList.add("is-changing");

      window.setTimeout(() => {
        this.updateContent({ bg, indexText, title, copy, buttonLabel, buttonUrl });
        this.section.classList.remove("is-changing");
      }, 180);
    }

    updateActiveStates(index) {
      this.cards.forEach((card, cardIndex) => {
        const isActive = cardIndex === index;
        card.classList.toggle("is-active", isActive);
        card.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    updateContent({ bg, indexText, title, copy, buttonLabel, buttonUrl }) {
      if (bg) {
        this.section.style.setProperty("--vcs-active-bg", `url("${bg}")`);
      }

      if (this.indexEl) {
        this.indexEl.textContent = indexText;
      }

      if (this.titleEl) {
        this.titleEl.textContent = title;
      }

      if (this.copyEl) {
        this.copyEl.innerHTML = copy;
      }

      if (this.button) {
        if (buttonUrl || buttonLabel) {
          this.button.hidden = false;

          if (buttonUrl) {
            this.button.setAttribute("href", buttonUrl);
          }

          if (this.buttonText) {
            this.buttonText.textContent = buttonLabel || "Shop Now";
          }
        } else {
          this.button.hidden = true;
        }
      }
    }

    startAutoplay() {
      this.stopAutoplay();

      this.timer = window.setInterval(() => {
        const nextIndex = (this.activeIndex + 1) % this.cards.length;
        this.activate(nextIndex, true);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      if (!this.autoplay) return;
      this.startAutoplay();
    }

    selectBlock(blockId) {
      const card = this.cards.find((item) => item.dataset.blockId === blockId);
      if (!card) return;

      const index = Number(card.dataset.vcsIndex);
      this.activate(index, true);
      this.stopAutoplay();
    }

    destroy() {
      this.stopAutoplay();

      this.cards.forEach((card) => {
        card.removeEventListener("click", this.handleCardClick);
        card.removeEventListener("mouseenter", this.handleMouseEnter);
      });

      this.section.removeEventListener("mouseenter", this.handleMouseEnter);
      this.section.removeEventListener("mouseleave", this.handleMouseLeave);
    }
  }

  const instances = new Map();

  function initSection(section) {
    const target = section.matches?.("[data-veiled-category-story]")
      ? section
      : section.querySelector?.("[data-veiled-category-story]");

    if (!target) return;

    const sectionId = target.dataset.sectionId;

    if (instances.has(sectionId)) {
      instances.get(sectionId).destroy();
      instances.delete(sectionId);
    }

    instances.set(sectionId, new VeiledCategoryStory(target));
  }

  function destroySection(section) {
    const target = section.matches?.("[data-veiled-category-story]")
      ? section
      : section.querySelector?.("[data-veiled-category-story]");

    if (!target) return;

    const sectionId = target.dataset.sectionId;
    const instance = instances.get(sectionId);

    if (instance) {
      instance.destroy();
      instances.delete(sectionId);
    }
  }

  function initAll() {
    document.querySelectorAll("[data-veiled-category-story]").forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    destroySection(event.target);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const section = event.target.closest("[data-veiled-category-story]");
    if (!section) return;

    const sectionId = section.dataset.sectionId;
    const instance = instances.get(sectionId);

    if (instance) {
      instance.selectBlock(event.detail.blockId);
    }
  });
})();